import type { WorksheetRules } from '../as400CellRuleKinds';

/**
 * The Matrix Classification worksheet's own rules, on top of its columns'
 * character limits. Append new entries; keep one ticket's entries together
 * under its comment.
 */
export const MATRIX_SHEET_RULES: WorksheetRules = {
  rules: [],
  autoFills: [],
  addDefaults: [],
};
